import type { FormOptions } from '@customTypes/types';

export const helpWithOptions: FormOptions = {
  greenLake: 'Workspace, User, Onboarding',
  computeOpsManagement: 'Compute Ops Management',
  dataServices: 'Data Services',
  osqbm: 'Billing, Metering, and Subscription',
  opsRamp: 'OpsRamp',
  dashboardsAndMonitoring: 'Dashboards and Monitoring',
  privateCloud: 'Private Cloud',
  greenLakeFlex: 'HPE GreenLake Flex Solutions',
  managedCloudService: 'HPE Managed Cloud Services',
  networkingArubaCentral: 'HPE Networking Aruba Central',
  // developerPortal: 'HPE Developer Portal',
  other: 'Other',
};
